import { DataItemType } from "components/EffectSearch/EffectSearch";

export const templateItems: DataItemType[] = [
  {
    label: "Fixed amount of 100 points",
    code: "100",
    codeRegexMatcher: /(?!)/g,
  },
];
